import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import RatingStar from "../../shared/images/rating-star.svg";
import Handshake from "../../shared/images/Handshake.png";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Label } from "@cars24/turbo-web/lib/label";
import WingLeft from "../../shared/images/wing-left.png";
import WingRight from "../../shared/images/wing-right.png";
import LazyImage from "../../shared/lazy-image";

const PreDeliveryInspectionRating = ({ details }) => {

    const { tokens } = useTokens();
    const { title: journeyTitle = "", sectionData: journeyList = [] } = details || {};

    const deliveryInspectionRatingReviewList = journeyList.map((item) => ({
        journeyTitle: item.title,
        text: item.description
    }));

    if (!deliveryInspectionRatingReviewList.length) {
        return null;
    }

    return (
        <div styleName={"styles.ratingSectionWrapper"}>
            <div styleName={"styles.overlay"} />

            <div styleName={"styles.iconWrapper"}>
                <LazyImage src={Handshake} alt="handshake-icon" styleName={"styles.handshakeIcon"} />
            </div>

            <div styleName={"styles.titleWrapper"}>
                <div styleName={"styles.divider"} />
                <Label level={2} color={tokens.text_default_text_inverse} fontWeight="semibold">
                    {journeyTitle}
                </Label>
                <div styleName={"styles.divider"} />
            </div>

            <div styleName={"styles.ratingText"}>
                {deliveryInspectionRatingReviewList.map((el, i) => (
                    <div styleName={"styles.text"} key={i}>
                        <LazyImage src={WingLeft} alt="left wing" styleName={"styles.wing styles.wingLeft"} />
                        <div styleName={"styles.content"}>
                            <Label level={1} fontWeight="semibold">
                                {el.journeyTitle} {i === 0 && <LazyImage src={RatingStar} alt="star" styleName={"styles.starIcon"} />}
                            </Label>
                            <Label level={4} fontWeight="regular" color={tokens.text_default_text_tertiary} isBold={true}>
                                {(el.text || "")}
                            </Label>
                        </div>
                        <LazyImage src={WingRight} alt="right wing" styleName={"styles.wing styles.wingRight"} />
                    </div>
                ))}
            </div>
        </div>
    );
};

PreDeliveryInspectionRating.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionRating;
